import { rvOnboardingMetadata } from 'graphql/reactiveVariables'

import { getFlowFlagsCombinedForm } from '../utils/getFlowFlagsCombinedForm'

export const useGetFlowFlagsCombinedForm = () => {
  return getFlowFlagsCombinedForm(rvOnboardingMetadata()?.flowFlags)
}
